import React from "react";
const FileUploader: React.FunctionComponent<{
  onOpen?: () => void;
}> = (props) => {
  return (
    <div
      className="uploader d-flex justify-content-center align-items-center flex-wrap cursor-pointer"
      onClick={props.onOpen}
    >
      <div className="text-center">
        <svg
          className="mb-2"
          xmlns="http://www.w3.org/2000/svg"
          width="57"
          height="44"
          viewBox="0 0 57 44"
          fill="none"
        >
          <path
            d="M13 13.2C13 10.78 14.98 8.80002 17.4 8.80002H24L28.4 4.40002H41.6L46 8.80002H52.6C53.767 8.80002 54.8861 9.26359 55.7113 10.0888C56.5364 10.9139 57 12.0331 57 13.2V35.2C57 36.367 56.5364 37.4861 55.7113 38.3113C54.8861 39.1365 53.767 39.6 52.6 39.6H17.4C16.233 39.6 15.1139 39.1365 14.2887 38.3113C13.4636 37.4861 13 36.367 13 35.2V13.2ZM35 35.2C37.9174 35.2 40.7153 34.0411 42.7782 31.9782C44.8411 29.9153 46 27.1174 46 24.2C46 21.2826 44.8411 18.4847 42.7782 16.4218C40.7153 14.3589 37.9174 13.2 35 13.2C32.0826 13.2 29.2847 14.3589 27.2218 16.4218C25.1589 18.4847 24 21.2826 24 24.2C24 27.1174 25.1589 29.9153 27.2218 31.9782C29.2847 34.0411 32.0826 35.2 35 35.2ZM35 30.8C34.1333 30.8 33.275 30.6293 32.4743 30.2976C31.6735 29.9659 30.946 29.4798 30.3331 28.8669C29.7202 28.2541 29.2341 27.5265 28.9024 26.7257C28.5707 25.925 28.4 25.0667 28.4 24.2C28.4 23.3333 28.5707 22.4751 28.9024 21.6743C29.2341 20.8736 29.7202 20.146 30.3331 19.5331C30.946 18.9203 31.6735 18.4341 32.4743 18.1024C33.275 17.7707 34.1333 17.6 35 17.6C36.7504 17.6 38.4292 18.2954 39.6669 19.5331C40.9046 20.7709 41.6 22.4496 41.6 24.2C41.6 25.9505 40.9046 27.6292 39.6669 28.8669C38.4292 30.1047 36.7504 30.8 35 30.8Z"
            fill="#1B1D1F"
          />
          <rect width="20" height="20" rx="10" fill="#4161C8" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5Z"
            fill="white"
          />
        </svg>
        <h4 className="font-sm font-weight-normal text-muted">
          click to browse
        </h4>
      </div>
    </div>
  );
};

export default FileUploader;
